<template>
  <v-layout column class="shrink my-4">
    <v-row no-gutters>
      <h2>Assigned to Me</h2>
      <v-spacer></v-spacer>
    </v-row>
    <v-divider class="my-2"></v-divider>
    <v-list dense>
      <template v-for="context in allTasksByContext">
        <v-subheader :key="context.id + 'label'">
          <c-icon class="mr-2" icon="context" color="grey" size="14" :autoMargin="false"></c-icon>
          {{ context.text }}
        </v-subheader>
        <v-divider :key="context.id + 'divider'"></v-divider>
        <v-list-item
          two-line
          v-for="task in context.assignedNotes"
          :key="task.noteId"
          :to="{
            name: 'context',
            params: { contextId: context.id },
            query: { page: task.pageId, note: task.noteId }
          }"
        >
          <v-list-item-avatar><v-icon>bookmark</v-icon></v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ getText(task.noteText) }}</v-list-item-title>
            <v-list-item-subtitle v-if="task.task">
              <v-icon small color="grey">assignment</v-icon>
              {{ task.task }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-layout>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
export default {
  components: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters('userWorkspaceLite', [
      'userWorkspaceLites',
      // 'allUserDocuments',
      'workspaceContexts'
    ]),
    ...mapState('userWorkspaceLite', ['allUserDocuments']),
    ...mapGetters('workspaces', ['workspaceContexts']),
    allTasksByContext() {
      const taskContexts = this.workspaceContexts.filter(
        c => c.assignedNotes && Object.values(c.assignedNotes).length
      );
      return taskContexts.length ? taskContexts : false;
    }
  },
  methods: {
    getText(html) {
      const template = document.createElement('template');
      template.innerHTML = html.trim();
      return template.content.firstChild.innerText;
    }
  }
};
</script>

<style></style>
